export const CompanyLogo = (props: { src: string; alt: string }) => {
  if (!props.src) {
    return null;
  }
  return (
    <div className="relative h-full flex-1 items-center flex">
      <img src={props.src} alt={props.alt} className="h-[40px] object-cover" />
    </div>
  );
};
